import omit from 'lodash/omit';

import { EntityInput } from '@evidentid/tprm-portal-lib/models/dashboard';

/**
 * Resolves the "Entity ID" cell of a bulk-import row into the `id` of a `PUT /insureds` element.
 *
 * A populated cell always addresses that entity. What an empty one means depends on the relying
 * party (PRODUCT-26139):
 *
 * - while it enforces contactEmail uniqueness, `id` is left off entirely, which asks the API to
 *   match the row on its `contactEmail` and create the entity when nothing matches. This is what
 *   bulk import did before the column existed, and what the column-less worksheets clients still
 *   have on disk depend on (PRODUCT-26313);
 * - once it allows non-unique contactEmails there is nothing safe to match on, so an empty cell
 *   has to mean "create a new entity" and reach the API as an explicit `null`.
 */
export function normalizeEntityId(entity: EntityInput, contactEmailUniquenessEnabled: boolean): EntityInput {
    const id = typeof entity.id === 'string' ? entity.id.trim() : '';
    if (id !== '' && id.toLowerCase() !== 'null') {
        return { ...entity, id };
    }
    // dropped, not nulled: `id: null` would ask the API for a brand new entity
    return contactEmailUniquenessEnabled ? omit(entity, 'id') : { ...entity, id: null };
}
